import { motion } from "framer-motion";
import { Check } from "lucide-react";

const ITEMS = [
  { num: "01", title: "Atendimento transparente", text: "Comunicação clara e orçamento sem surpresas." },
  { num: "02", title: "Especialistas em câmbio automático", text: "Foco técnico na transmissão do seu veículo." },
  { num: "03", title: "Mecânica completa", text: "Serviço integral, do diagnóstico ao reparo final." },
  { num: "04", title: "Diagnóstico preciso", text: "Equipamentos modernos e leitura computadorizada." },
  { num: "05", title: "Compromisso com o cliente", text: "Sua confiança é o nosso maior patrimônio." },
  { num: "06", title: "Oficina em Jundiaí/SP", text: "Localização estratégica e fácil acesso." },
  { num: "07", title: "Responsabilidade total", text: "Trabalhamos com garantia e ética profissional." },
];

export default function Differentials() {
  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/4488639/pexels-photo-4488639.jpeg?auto=compress&cs=tinysrgb&w=1600&q=70"
          alt=""
          width="1600"
          height="900"
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/95 to-black/70" />
        <div className="absolute inset-0 bg-noise opacity-[0.04]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Left: Heading */}
          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="sticky top-32"
            >
              <p className="text-xs uppercase tracking-[0.35em] text-red-500 font-bold mb-6 flex items-center gap-3">
                <span className="w-8 h-px bg-red-500" /> Diferenciais
              </p>
              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase leading-[1] tracking-tighter text-white">
                Por que<br />
                escolher a<br />
                <span className="text-red-600">Full Force?</span>
              </h2>
              <p className="mt-8 text-zinc-400 text-base md:text-lg font-body leading-relaxed max-w-md">
                Mais que uma oficina — uma parceira automotiva preparada para entregar resultado com confiança em cada serviço.
              </p>
            </motion.div>
          </div>

          {/* Right: List */}
          <div className="lg:col-span-7 space-y-2">
            {ITEMS.map((item, i) => (
              <motion.div
                key={item.num}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.07 }}
                data-testid={`differential-${item.num}`}
                className="group flex items-start gap-6 py-6 border-b border-white/5 hover:border-red-600/40 transition-colors duration-300"
              >
                <div className="font-display text-3xl md:text-4xl font-black text-zinc-700 group-hover:text-red-600 transition-colors duration-300 min-w-[60px]">
                  {item.num}
                </div>
                <div className="flex-1 pt-1">
                  <h3 className="font-display text-xl md:text-2xl font-bold text-white uppercase tracking-tight leading-tight">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm md:text-base text-zinc-400 leading-relaxed">
                    {item.text}
                  </p>
                </div>
                <Check
                  className="text-red-600 mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  size={20}
                  strokeWidth={2}
                />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
